import React, { useState, useEffect } from "react";
import { ButtonDropdown } from "../../../../src/stories/elements/ButtonDropdown";
import CollectionFilters from "@stories/ecommerce/Collection/CollectionFilters";
import { CloseIcon, FilterIcon } from "@src/stories/elements/Icons";
import { mobileBreakpoint } from "../../../../entrypoints/theme";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

export const CollectionToolbar = ({
  sortingOptions,
  changeSort,
  initialSortOption,
  onViewChange,
  currentView,
  totalResults, 
  filters,
  setSelectedFilters,
  selectedFilters, 
  changeFilter,
  isFilterDrawerOpen,
  toggleFilterDrawer,
  selectedFilterCounts,
  totalSelectedFilters,
  clearAllFilters,
}) => {
  const [selectedSortOption, setSelectedSortOption] = useState(initialSortOption);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const handleSortChange = (selectedOption) => {
    const [field, direction] = selectedOption.value.split("|");
    const selectedOptionValue = sortingOptions.find(option => option.field === field && option.direction === direction);
    setSelectedSortOption(selectedOptionValue);
    changeSort({ field, direction });
  };

  const dropdownOptions = sortingOptions?.map((option, index) => ({
    id: index,
    label: option.label,
    value: `${option.field}|${option.direction}`,
    className: selectedSortOption?.field === option.field && selectedSortOption?.direction === option.direction ? "font-bold" : "",
  })) || [];


  console.log(selectedSortOption);

  useEffect(() => {
    if (!selectedSortOption && sortingOptions.length > 0) {
      const defaultOption = sortingOptions.find(option => option.isDefault);
      if (defaultOption) {
        setSelectedSortOption(defaultOption);
      }
    }
  }, [sortingOptions]);

    useEffect(() => {
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);

  const dropdownText = selectedSortOption?.label 
    ? `Sort by: ${selectedSortOption.label}` 
    : "Sort by";

  return (
    <>
      <div className="flex flex-col mb-3">
        <div className="flex flex-wrap items-center gap-3 lg:gap-0 lg:justify-between lg:flex-nowrap lg:flex-row-reverse">
          <div className="flex w-full lg:w-auto">
            <button
              className={`px-[15px] py-[5px] font-semibold font-body text-base/[22px] capitalize h-auto min-h-[auto] lg:h-[32px] lg:w-[130px] ${currentView === "product" ? "bg-primary text-white" : "bg-[#F4F6F5] text-primary"}`}
              onClick={() => onViewChange("product")}
            >
              Product View
            </button>
            <button
              className={`px-[15px] py-[5px font-semibold font-body text-base/[22px] capitalize h-auto min-h-[auto] lg:h-[32px] lg:w-[130px] ${currentView === "outfit" ? "bg-primary text-white" : "bg-[#F4F6F5] text-primary"}`}
              onClick={() => onViewChange("outfit")}
            >
              Outfit View
            </button>
          </div>
          <div className="w-full toolbar-items flex flex-row gap-2">
            <button 
              onClick={toggleFilterDrawer}
              className="flex w-1/2 lg:w-[167px] gap-[10px] h-10 min-h-0 max-h-10 items-center justify-center px-4 py-2 bg-[#F4F6F5] text-primary font-semibold normal-case"
            >
              <span>Filters{totalSelectedFilters > 0 ? ` (${totalSelectedFilters})` : ''}</span>
              <FilterIcon/>
            </button>
            <div className={`w-1/2 lg:w-auto h-10 min-h-0 max-h-10   relative flex items-center justify-center`} style={{ minWidth: selectedSortOption?.label ? `201px` : `167px`}}>
              <ButtonDropdown
                key={`dropdown-${selectedSortOption?.value || "default"}`}
                text={dropdownText}
                type={'filter'}
                options={dropdownOptions}
                onSelect={handleSortChange}
                inputType={"radio"}
              />
            </div>
          </div>
        </div>
      </div>

      <div 
        className={`fixed inset-0 bg-black bg-opacity-30 z-40 transition-opacity ${isFilterDrawerOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={toggleFilterDrawer}
      ></div>
      
      {/* Z index value is based from the gorgias chat widget which is 2147483636 */}
      <div 
       className={`fixed left-0 top-0 h-full w-full md:w-96 bg-white z-[2147483637] transform transition-transform duration-300 ease-in-out ${isFilterDrawerOpen ? 'translate-x-0' : '-translate-x-full'} overflow-y-auto`}
      >
        <div className="">
          <div className="flex items-center justify-between px-2 lg:px-5 py-5 border-tertiary border-b">
            <div className={`${isMobile ? 'h2' : 'h5'}  font-semibold text-primary font-body`}>Filters</div>
            <button 
              onClick={toggleFilterDrawer}
              className="text-gray-500 hover:text-gray-700 w-6 h-6 p-0 min-h-0"
            >
              <CloseIcon />
            </button>
          </div>
          
          {filters && (
            <CollectionFilters 
              changeFilter={changeFilter} 
              filters={filters} 
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              totalResults={totalResults}
              selectedFilterCounts={selectedFilterCounts}
              totalSelectedFilters={totalSelectedFilters}
              clearAllFilters={clearAllFilters}
              toggleFilterDrawer={toggleFilterDrawer}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CollectionToolbar;